import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{attrs:{"label":"Serviço","placeholder":"Selecione o serviço da API","items":_vm.items,"loading":_vm.loading,"readonly":_vm.disabled,"disabled":!_vm.api,"item-text":"service","item-value":"id","rules":_vm.rules},on:{"change":_vm.onChange},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }